import { render, staticRenderFns } from "./TemplateWppVariaveis.vue?vue&type=template&id=1609a76e&scoped=true&"
import script from "./TemplateWppVariaveis.vue?vue&type=script&lang=js&"
export * from "./TemplateWppVariaveis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1609a76e",
  null
  
)

export default component.exports